import { IconButton, Stack } from '@fluentui/react';
import React, { useState } from 'react';
import { BusinessUnitRow } from '../list';
import { FormModal } from './FormModal';

export interface BusinessUnitModalProps {
  existingBusinessUnit?: BusinessUnitRow;
}

export const BusinessUnitModal: React.FC<BusinessUnitModalProps> = ({
  existingBusinessUnit,
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const { _isUpdatable } = { ...existingBusinessUnit };

  return (
    <Stack>
      <IconButton
        iconProps={{ iconName: 'Edit' }}
        onClick={() => setIsOpen(true)}
        disabled={!_isUpdatable}
      />
      {isOpen && (
        <FormModal
          existingBusinessUnit={existingBusinessUnit}
          onClose={() => setIsOpen(false)}
        />
      )}
    </Stack>
  );
};
